import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Cases } from './components/Cases';
import { Process } from './components/Process';
import { Stats } from './components/Stats';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Hero />
      <Services />
      <Cases />
      <Process />
      <Stats />
      <CTA />
      <Footer />
    </div>
  );
}
